import React from 'react';
import { CurrencyDollarIcon, ArrowTrendingUpIcon, ArchiveBoxIcon } from '@heroicons/react/24/outline';
import { InventoryStats } from '../../types/inventory';

interface InventoryValueDisplayProps {
  stats: InventoryStats;
  className?: string;
}

const InventoryValueDisplay: React.FC<InventoryValueDisplayProps> = ({ stats, className = '' }) => {
  return (
    <div className={`bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-lg p-6 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          Inventory Value
        </h3>
        <ArchiveBoxIcon className="h-6 w-6 text-blue-600 dark:text-blue-400" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Total Value */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-1 mb-1">
            <CurrencyDollarIcon className="h-5 w-5 text-green-600 dark:text-green-400" />
            <span className="text-sm text-gray-600 dark:text-gray-400">Total</span>
          </div>
          <p className="text-2xl font-bold text-green-600 dark:text-green-400">
            ${stats.total_value.toFixed(2)}
          </p>
        </div>

        {/* Sold Value */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-1 mb-1">
            <ArrowTrendingUpIcon className="h-5 w-5 text-blue-600 dark:text-blue-400" />
            <span className="text-sm text-gray-600 dark:text-gray-400">Sold</span>
          </div>
          <p className="text-2xl font-bold text-blue-600 dark:text-blue-400">
            ${stats.sold_value.toFixed(2)}
          </p>
        </div>

        {/* Unsold Value */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-1 mb-1">
            <ArchiveBoxIcon className="h-5 w-5 text-orange-600 dark:text-orange-400" />
            <span className="text-sm text-gray-600 dark:text-gray-400">Unsold</span>
          </div>
          <p className="text-2xl font-bold text-orange-600 dark:text-orange-400">
            ${stats.unsold_value.toFixed(2)}
          </p>
        </div>
      </div>

      {/* Summary */}
      <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
        <div className="flex justify-between text-sm text-gray-600 dark:text-gray-400">
          <span>{stats.total_items} total items</span>
          <span>{stats.sold_items} sold</span>
          <span>{stats.unsold_items} unsold</span>
        </div>
      </div>
    </div>
  );
};

export default InventoryValueDisplay;
